var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKarteWechseln(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Karte-Wechseln__Icn/40px/Karte-Wechseln",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Karte-Wechseln__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Karte-Wechseln__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.9443359,25.5128994 L 17.9443359,31.5128994 L12.9443359,28.5132513 L17.9443359,25.5128994 Z M22,9 C27.5228475,9 32,13.4771525 32,19 C32,24.5228475 27.5228475,29 22,29 C21.6624661,29 21.328838,28.9832771 20.9998991,28.9506147 L21,20.4824219 L12.1091966,20.4829218 C12.0372675,19.9990562 12,19.5038802 12,19 C12,13.4771525 16.4771525,9 22,9 Z M8,21.5128994 L13,24.5132513 L8,27.5128994 L8,21.5128994 Z M26.2114641,20.5008865 L23,20.5 L23.0008898,27.0721464 C24.5245276,26.2808667 25.8848829,23.7630248 26.2114641,20.5008865 Z M30.1985249,20.500939 L27.9329023,20.5005258 C27.7306967,22.740123 27.0828489,24.7364612 26.1446683,26.2306911 L26.2059929,26.195589 C28.2627558,24.9907652 29.7568374,22.929311 30.1985249,20.500939 Z M26.1451954,11.7691404 L26.2426407,11.9289322 C27.2625497,13.6287806 27.9169832,15.937755 27.992641,18.5003553 L30.3185997,18.5003223 C30.1481134,15.6175197 28.5121421,13.1289559 26.1451954,11.7691404 Z M23.0008898,10.9278536 L23,18.5 L26.2775776,18.4998018 C26.1555056,14.7581785 24.6769959,11.7983156 23.0008898,10.9278536 Z M21.000108,10.9273356 C19.3237398,11.7970637 17.8447815,14.7569101 17.722455,18.4988044 L21,18.499 L21.000108,10.9273356 Z M17.8553317,11.7693089 L17.7940071,11.804411 C15.4601478,13.1715541 13.8507969,15.6416942 13.6814592,18.4993264 L16.0073885,18.4993581 C16.0855869,15.8560187 16.7796083,13.4826016 17.8553317,11.7693089 Z",
    id: ".._.._src_svg_Icn_40px_Karte-Wechseln__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKarteWechseln);
export default __webpack_public_path__ + "static/media/Karte-Wechseln.3a45f02dc5d2f2480f0677dbee581264.svg";
export { ForwardRef as ReactComponent };